var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"variant-item left-index-wrapper",class:{
            selected : _vm.questionAnswered && _vm.selectedVariant == _vm.keynumber,
            correct : _vm.isSelectionCorrect,
            incorrect : _vm.questionAnswered && !_vm.isSelectionCorrect,
        },on:{"click":function($event){return _vm.selectVariant(_vm.keynumber)}}},[_c('span',{staticClass:"left-index"},[_vm._v(_vm._s(_vm.keynumber))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }